<template>
  <v-container class="fill-height lighten-2" :class="$config.theme.primaryColor" fluid>
    <v-layout align-center justify-center>
      <v-flex xs8 sm5 md3>
        <form @submit.prevent="onsubmit"> 
          <v-card class="elevation-12">
            <v-toolbar  color="blue" flat>          
              <img src="logo.png" style="height:40px;" />        
              <v-toolbar-title class="white--text subtitle-2 ml-2">Login {{ $config.title }}</v-toolbar-title>                       
            </v-toolbar>
            <v-card-text>            
              <v-text-field
                label="Login"
                v-model="username"
                prepend-icon="person"
                type="text"
                :error="!!userErrors.length"
                :error-messages="userErrors"
              ></v-text-field>

              <v-text-field
                id="password"
                label="Password"
                v-model="password"
                prepend-icon="lock"                
                :error="!!passErrors.length"
                :error-messages="passErrors"
                :append-icon="showPass ? 'visibility' : 'visibility_off'"                    
                :type="showPass ? 'text' : 'password'"
                @click:append="showPass = !showPass"
                suggested="current-password" 
              ></v-text-field>
           
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" :loading="loading" type="submit">Login</v-btn>
            </v-card-actions>
          </v-card>
        </form>
      </v-flex>
    </v-layout>
  </v-container>    
</template>
<script>
import model from '@/utils/models/User'
export default {
    props: {
      source: String,
    },
    data : () => ({
      username  : null,
      userErrors: [],
      password  : null,
      passErrors: [],
      loading   : false,
      showPass  : false,
    }),
    computed: {
      formReady () {
        return !this.userErrors.length && !this.passErrors.length
      },
    },
    methods:{
      onsubmit () {
        this.userErrors = this.username ? [] : ['Username is required']
        this.passErrors = this.password ? [] : ['Password is required']
        if (!this.formReady) {
          return
        }
        this.loading = true;
        model.login(this.username, this.password).then(res=>{
          this.loading = false;
          if(res.status === 200 && res.data){
            window.getApp.$emit('showSnackbar', {show:true, text :'Your login is Successfully.', color: 'green'});
            model.set(res.data);   
            setTimeout(()=>{this.$router.push({ name: 'dashboard' })}, 300);
          } else {
            //this.userErrors = ['please check your email/username'];
            this.passErrors = ['please check your password'];
            return;
          }
        });      
      }
    }
  }
</script>